import _ from 'lodash'

const plagResult = {
    namespaced: true,
    state: {
        noPlagCurrentPopup: '',
        noPagePlagCurrentPopup: '',
        isShowPlagPopup: false,
        resultLineCurrentPopup: '',
        resultPlagCurrentPopup: '',
        dataPlagiarismCurrent: '',
        lstResultPlagIgnoredCurrent: [],

        // New result viewer
        similarities: {},
        similarSentences: {},
        similarSources: {},
        sourceSentence: {},
        configDocumentScore: {}
    },
    mutations: {
        UPDATE_PLAG_NO(state, noPlag) {
            state.noPlagCurrentPopup = noPlag
        },
        UPDATE_NO_PAGE_PLAG(state, noPagePlag) {
            state.noPagePlagCurrentPopup = noPagePlag
        },
        UPDATE_IS_SHOW_PLAG_POPUP(state, isShowPlagPopup) {
            state.isShowPlagPopup = isShowPlagPopup
        },
        UPDATE_RESULT_PLAG_CURRENT_POPUP(state, resultPlagCurrentPopup) {
            state.resultPlagCurrentPopup = resultPlagCurrentPopup
        },
        UPDATE_RESULT_LINE_CURRENT_POPUP(state, resultLineCurrentPopup) {
            state.resultLineCurrentPopup = resultLineCurrentPopup
        },
        UPDATE_DATA_PLAGIARISM_CURRENT(state, dataPlagiarism) {
            state.dataPlagiarismCurrent = dataPlagiarism
        },
        UPDATE_LST_RESULT_PLAG_IGNORED_CURRENT(state, {resultPlagIgnored, isUndo}) {
            // Empty listResultPlagIgnoredCurrent if resultPlagIgnored is either null or empty
            if (resultPlagIgnored == null || resultPlagIgnored.length === 0) {
                state.lstResultPlagIgnoredCurrent = []
            } else {
                let shouldAdd = true
                // Delete element which has id === resultPlagIgnored.plaId
                for (let [index, resultPlag] of state.lstResultPlagIgnoredCurrent.entries()) {
                    // console.log('resultPlag ', resultPlag)
                    // console.log('resultPlag Id', resultPlag.plaId)
                    // const newSentenceIds = resultPlagIgnored.sentenceIds.sort()
                    if (_.isEqual(_.sortBy(resultPlag.sentenceIds), _.sortBy(resultPlagIgnored.sentenceIds))) {
                        // Delete
                        if (isUndo || !resultPlagIgnored.isIgnored) {
                            state.lstResultPlagIgnoredCurrent.splice(index, 1)
                        } else {
                            state.lstResultPlagIgnoredCurrent[index] = resultPlagIgnored
                        }
                        shouldAdd = false
                    }
                }

                if (!isUndo && shouldAdd) {
                    state.lstResultPlagIgnoredCurrent.push(resultPlagIgnored)
                }
            }
        },
        UPDATE_DATA_PLAGIARISM_IGNORED_BY_USER(state, {plaId, value}) {
            state.dataPlagiarismCurrent.find((e) => e.id === plaId).ignoredByUser = value
        },
        UPDATE_SIMILARITIES(state, similarities) {
            state.similarities = similarities
        },
        UPDATE_SIMILAR_SOURCES(state, similarSources) {
            state.similarSources = similarSources
        },
        UPDATE_SIMILAR_SENTENCES(state, similarSentences) {
            state.similarSentences = similarSentences
        },
        UPDATE_SOURCE_SENTENCES(state, sourceSentences) {
            state.sourceSentence = sourceSentences
        },
        UPDATE_CONFIG_DOCUMENT_SCORE(state, config) {
            state.configDocumentScore = config
        }
    },
    actions: {
        updatePlagNo({ commit }, noPlag) {
            commit('UPDATE_PLAG_NO', noPlag)
        },
        updateNoPagePlagCurrentPopup({ commit }, noPagePlag) {
            commit('UPDATE_NO_PAGE_PLAG', noPagePlag)
        },
        updateIsShowPlagPopup({ commit }, isShowPlagPopup) {
            commit('UPDATE_IS_SHOW_PLAG_POPUP', isShowPlagPopup)
        },
        updateResultPlagCurrentPopup({ commit }, resultPlagCurrentPopup) {
            commit('UPDATE_RESULT_PLAG_CURRENT_POPUP', resultPlagCurrentPopup)
            // console.log('UPDATE_RESULT_PLAG_CURRENT_POPUP', resultPlagCurrentPopup)
        },
        updateResultLineCurrentPopup({ commit }, resultLineCurrentPopup) {
            commit('UPDATE_RESULT_LINE_CURRENT_POPUP', resultLineCurrentPopup)
        },
        updateDataPlagiarismCurrent({ commit }, dataPlagiarism) {
            commit('UPDATE_DATA_PLAGIARISM_CURRENT', dataPlagiarism)
        },
        updateLstResultPlagIgnoredCurrent({ commit }, {resultPlagIgnored, isUndo}) {
            commit('UPDATE_LST_RESULT_PLAG_IGNORED_CURRENT', {resultPlagIgnored, isUndo})
        },
        updateDataPlagiarismIgnoredByUser({ commit }, {plaId, value}) {
            commit('UPDATE_DATA_PLAGIARISM_IGNORED_BY_USER', {plaId, value})
        },

        // New result viewer
        updateSimilarities({ commit }, similarities) {
            commit('UPDATE_SIMILARITIES', similarities)
        },
        updateSimilarSources({ commit }, similarSources) {
            commit('UPDATE_SIMILAR_SOURCES', similarSources)
        },
        updateSimilarSentences({ commit }, similarSentences) {
            commit('UPDATE_SIMILAR_SENTENCES', similarSentences)
        },
        updateSourceSentences({ commit }, sourcesSentences) {
            commit('UPDATE_SOURCE_SENTENCES', sourcesSentences)
        },
        updateConfigDocumentScore({ commit }, config) {
            commit('UPDATE_CONFIG_DOCUMENT_SCORE', config)
        }
    },
    getters: {
        noPlagCurrentPopup: state => state.noPlagCurrentPopup,
        noPagePlagCurrentPopup: state => state.noPagePlagCurrentPopup,
        noLinePlagCurrentPopup: state => state.noLinePlagCurrentPopup,
        isShowPlagPopup: state => state.isShowPlagPopup,
        resultPlagCurrentPopup: state => state.resultPlagCurrentPopup,
        resultLineCurrentPopup: state => state.resultLineCurrentPopup,
        dataPlagiarismCurrent: state => state.dataPlagiarismCurrent,
        lstResultPlagIgnoredCurrent: state => state.lstResultPlagIgnoredCurrent,

        // New result viewer
        getSimilarity: state => id => state.similarities[id],
        getSimilarSource: state => id => state.similarSources[id],
        getSimilarSentence: state => id => state.similarSentences[id],
        getSourceSentence: state => id => state.sourceSentence[id],

        getAllSimilarities: state => state.similarities,
        getAllSimilarSentences: state => state.similarSentences,
        getAllSourceSentences: state => state.sourceSentence,
        getAllSimilarSources: state => state.similarSources,

        getConfigDocumentScore: state => state.configDocumentScore
    }
}

export default plagResult
